const ITEM_LIST_ID = 'verify-item-list';

export const visibility = {
  aboveFull: 'aboveFull',
  belowFull: 'belowFull',
  abovePartial: 'abovePartial',
  belowPartial: 'belowPartial',
  visible: 'visible',
};

class ItemVisibilityServiceClass {
  isItemVisible(itemId) {
    const parent = document.getElementById(ITEM_LIST_ID);
    const child = document.getElementById(itemId);

    if (!parent || !child) {
      return false;
    }
    const parentBounds = parent.getBoundingClientRect();
    const childBounds = child.getBoundingClientRect();

    const itemTop = childBounds.top - parentBounds.top;
    const bottomVisible = itemTop + childBounds.height < parentBounds.height;
    const topVisible = childBounds.top >= parentBounds.top && childBounds.top <= parentBounds.bottom;
    return bottomVisible && topVisible;
  }

  getVisibility(parentRect, childRect) {
    // reminder: for BoundingClientRect (0,0) is top left
    if (childRect.bottom <= parentRect.top) {
      return visibility.aboveFull;
    }

    if (childRect.top >= parentRect.bottom) {
      return visibility.belowFull;
    }

    if (childRect.top < parentRect.top && childRect.bottom > parentRect.top) {
      return visibility.abovePartial;
    }

    if (childRect.bottom > parentRect.bottom && childRect.top < parentRect.bottom) {
      return visibility.belowPartial;
    }

    return visibility.visible;
  }
}

export const ItemVisibilityService = new ItemVisibilityServiceClass();
